// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: "14557d50-146b-4566-a91a-15cf8466c7ee",
    authority: "https://login.microsoftonline.com/fcb2b37b-5da0-466b-9b83-0014b67a7c78",
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin + '/',
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
  scopes: ["14557d50-146b-4566-a91a-15cf8466c7ee/.default"],
};